import RefineWithAIButton from '@shared/refinement/RefineWithAIButton'
import { useFormContext, useWatch } from 'react-hook-form'
import { NominateFormData } from './useNominateForm'
import useNominationResponseRefinement from './useNominationResponseRefinement'

type RefineNominationResponseButtonProps = {
  responseIndex: number
}

const RefineNominationResponseButton: React.FC<RefineNominationResponseButtonProps> = ({
  responseIndex,
}) => {
  const {
    refineMessage,
    deleteRefinementMessage,
    hasRefined,
    isPendingRefineMessage,
    isPendingUndoRefinedMessage,
  } = useNominationResponseRefinement({ responseIndex })
  const { control, clearErrors } = useFormContext<NominateFormData>()
  const message = useWatch({ control, name: `responses.${responseIndex}.valueString` })

  return (
    <RefineWithAIButton
      isMessageEmpty={(message ?? '').trim().length === 0}
      hasRefined={hasRefined}
      isPendingRefineMessage={isPendingRefineMessage}
      isPendingUndoRefinedMessage={isPendingUndoRefinedMessage}
      onBeforeRefine={() => clearErrors('root')}
      onRefine={refineMessage}
      onUndo={deleteRefinementMessage}
      refineButtonId={`refineNominationResponseButton-${responseIndex}`}
      undoButtonId={`btnUndoRefineNominationResponse-${responseIndex}`}
    />
  )
}

export default RefineNominationResponseButton
